import React, { useContext } from 'react'
import css from "./logout.module.scss"
import { AuthContext } from "../../../context/auth";

export const LogoutModal = () => {
  const { setLogOutModal, logout } = useContext(AuthContext)
  return (
    <div className={css.modalWrapper}>
      <div className={css.modalContent}>
        <div style={{ position: 'relative', justifyContent: 'center', display: 'flex', width: '100%' }}>
          <span className={css.closeIcon} onClick={() => setLogOutModal(false)}>
            <i className='fal fa-times' />
          </span>
          <span className={css.icon}>
            <i class="fal fa-sign-out"></i>
          </span>
        </div>
        <h2>Are You Sure? </h2>
        <p style={{ marginBottom: '20px' }}>You will be logged out of <span>Identifyn.</span></p>
        <button className={`btn ${css.ctaBtn}`} onClick={() => {
          logout()
          setLogOutModal(false)
        }}>Log Out</button>
        <button className={`btn ${css.transparentBtn}`} onClick={() => {
          setLogOutModal(false)
        }}>Cancel</button>
      </div>
    </div>
  )
}